import React from 'react';
import { generateReactKey } from './commonUtils';

export const getSplittedText = (text, delimiter) => text.split(new RegExp(`(${delimiter})`, 'g'));

/**
 * Wrap words with delimiters with provided element with classNames
 * @param {string} text The text with delimiters
 * @param {Object} configurationObject e.g { delimiter: '%', elementToWrap: 'span', className: 'red' }
 * @returns {Object} Fragment with wrapped words without delimiters
 */
export const formatText = (text, { delimiter, elementToWrap, className }) => {
    const splittedText = getSplittedText(text, `${delimiter}.*?${delimiter}`);
    return (
        <>
            {splittedText.map((word, index) => {
                if (word.startsWith(delimiter)) {
                    return React.createElement(
                        elementToWrap,
                        { key: generateReactKey(index), className },
                        word.replace(new RegExp(`${delimiter}`, 'g'), ''),
                    );
                }
                return `${word} `;
            })}
        </>
    );
};
